module.exports = __webpack_public_path__ + "CircleHead.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CircleHead.png
// module id = 842
// module chunks = 0